<ng-container *transloco="let _t">

<h3>{{ _t('mdr-objectif-form-h3-0') }}</h3>
<div class="row">
  <div class="col-6">

	<p>
		<label>{{ _t('mdr-objectif-form-label-0') }}</label>
		<input type="text" [(ngModel)]="objectif.name"
				[placeholder]="_t('mdr-objectif-form-placeholder-0')" >
	</p>
	<p>
		<label>{{ _t('mdr-objectif-form-label-1') }}</label>
		<textarea [(ngModel)]="objectif.redaction"
				[placeholder]="_t('mdr-objectif-form-placeholder-1')"
		></textarea>
	</p>
  </div>
  <div class="col-6">
	<p>
		<label>{{ _t('mdr-objectif-form-label-2') }}</label>
		<input type="date" [(ngModel)]="objectif.start"  
		[ngClass]="{'error': objectif.start==''}" />
	</p>
	<p>
		<label>{{ _t('mdr-objectif-form-label-3') }}</label>
		<input type="date" [(ngModel)]="objectif.end"  
		[ngClass]="{'error': objectif.end==''}" />
	</p>

	<p>{{ _t('mdr-objectif-form-p-0') }}</p>
	<p class="text-right">
		<button mat-raised-button color="basic" (click)='dialogRef.close(objectif)'>
			{{ _t('Valider') }}
		</button>
		&nbsp;
		<button mat-raised-button color="warn" (click)='dialogRef.close()'>
			{{ _t('Annuler') }}
		</button>
	</p>
  </div>


</div>

</ng-container>